import { curry } from '@waves-tools/curry';

export const addNamespace = curry((namespace: string, classNames: string): string => {
    return classNames.trim().split(/\s+/)
        .map((className) => `${namespace}__${className}`)
        .join(' ');
});
